module.exports = __webpack_public_path__ + "05a7fba0ba930dc28b8ae0e5d48ead0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/_common/Slider/images/image3.png
// module id = Asrm
// module chunks = 0